<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { useToast } from 'vue-toastification';

export default {
inject: ['setLoading'],  
  props:{
   roles: {
    type: Array,
    required: true
   },
   industries: {
    type: Array,
    required: true
   } 
  },
  data() {
    return {
     errors: {}, 
     toast: useToast(),
     id: '',
     role: '',
     industry: '',
     name: '',
     email: '',
     mobile: '',
     password: '',
     company_name: '',
     activation_date: '',
     activation_remark: '',
     user_limit: 0,
    };
  },
  methods: {
   add(){
    this.resetForm();
   },
   editAdmin(admin) {
    this.id = admin.id;
    this.role = this.roles.find(r => r.id === admin.role_id);
    this.industry = this.industries.find(i => i.id === admin.company.industry_id);
    this.name = admin.name;
    this.email = admin.email;
    this.mobile = admin.mobile;
    this.password = admin.password;
    this.company_name = admin.company.company_name;
    this.activation_date = admin.company.activation_date;
    this.activation_remark = admin.company.activation_remark;
    this.user_limit = admin.company.user_limit;
   },  

   async addUpdateAdmin(){
    this.errors = {};
    this.setLoading(true); 

    try{
     if(this.id){
      //UPDATE USER
      const response = await axios.put('/users/update', {
       id: this.id, 
       role_id: this.role?.id, 
       parent_id: 0,       
       name: this.name,
       email: this.email,
       mobile: this.mobile,
       password: this.password,
      });

      //UPDATE COMPANY
      const company_response = await axios.post('/users/company/update', {
       user_id: this.id, 
       industry_id: this.industry?.id,
       company_name: this.company_name,        
       activation_date: this.activation_date,
       activation_remark: this.activation_remark,
       user_limit: this.user_limit,
       password: this.password,
      });

      this.toast.success(response.data.message);
     }else{
      //CREATE
      const response = await axios.post('/users/create-admin', {
        role_id: this.role?.id,        
        industry_id: this.industry?.id,
        name: this.name,
        email: this.email,
        mobile: this.mobile,
        password: this.password,
        company_name: this.company_name,
        activation_date: this.activation_date,
        activation_remark: this.activation_remark,
        user_limit: this.user_limit
      });
      this.toast.success(response.data.message);
     }

     this.$emit('updated'); 
     this.closeModal('admin_modal');
     this.resetForm();
    }catch(error){
     if(error.type == 'validation'){  
      this.errors = error.errors;
     }else{
      this.toast.error(error.message);
     }
    }finally{
     this.setLoading(false); 
    }
   },

  async deleteAdmin(){
   this.setLoading(true);
   try{
    const response = await axios.post('/users/delete', {
     id: this.id 
    });
    this.toast.success(response.data.message);
    this.$emit('updated');
    this.closeModal('delete_modal');
   }catch(error){
    this.toast.error(error.message);
   }finally{
    this.setLoading(false);
   }
  }, 

  closeModal(modalId) {
   const modalEl = document.getElementById(modalId);
   const modal = Modal.getInstance(modalEl);
   if (modal) modal.hide();
  },

  resetForm() {
   this.id = null;
   this.role = '';
   this.industry = '';
   this.name = '';
   this.email = '';
   this.mobile = '';
   this.password = '';
   this.company_name = '';
   this.activation_date = '';
   this.activation_remark = '';
   this.user_limit = 1;
   this.errors = {};
  },

  },
};
</script>

<template>
  <!-- Add -->
  <div class="modal fade" id="admin_modal">
    <div class="modal-dialog modal-dialog-centered modal-mg w-100">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ id ? 'Edit' : 'Add' }} User</h4>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="addUpdateAdmin">
        <div class="modal-body pb-0">
        
        <div class="row">
         
         <div class="col-md-7">
         <div class="mb-3">
          <label class="form-label">Name</label>
          <input type="text" class="form-control" v-model="name" />
          <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
         </div>
         </div>

         <div class="col-md-5">
         <div class="mb-3">
          <label class="form-label">Mobile No</label>
          <input type="text" class="form-control" v-model="mobile" />
          <div v-if="errors.mobile" class="text-danger small mt-1">{{ errors.mobile[0] }}</div>
         </div>
         </div>
              
        </div>

        <div class="row">
         
         <div class="col-md-7">
         <div class="mb-3">
          <label class="form-label">Email ID</label>
          <input type="text" class="form-control" v-model="email" />
          <div v-if="errors.email" class="text-danger small mt-1">{{ errors.email[0] }}</div>
         </div>
         </div>

         <div class="col-md-5">
         <div class="mb-3">
          <label class="form-label">Password</label>
          <input type="text" class="form-control" v-model="password" />
          <div v-if="errors.password" class="text-danger small mt-1">{{ errors.password[0] }}</div>
         </div>
         </div>
              
        </div>

        <div class="row">
         <div class="col-md-12">
         <div class="mb-3">
          <label class="form-label">Company Name</label>
          <input type="text" class="form-control" v-model="company_name" />
          <div v-if="errors.company_name" class="text-danger small mt-1">{{ errors.company_name[0] }}</div>
         </div>
         </div>
        </div>

        <div class="row">
         
         <div class="col-md-4">
         <div class="mb-3">
          <label class="form-label">Activation Date</label>
          <input type="date" class="form-control" v-model="activation_date" />
          <div v-if="errors.activation_date" class="text-danger small mt-1">{{ errors.activation_date[0] }}</div>
         </div>
         </div>

         <div class="col-md-4">
         <div class="mb-3">
          <label class="form-label">Activation Remark</label>
          <input type="text" class="form-control" v-model="activation_remark" />
          <div v-if="errors.activation_remark" class="text-danger small mt-1">{{ errors.activation_remark[0] }}</div>
         </div>
         </div>

         <div class="col-md-4">
         <div class="mb-3">
          <label class="form-label">User Limit</label>
          <input type="number" class="form-control" v-model="user_limit" min="1" />
          <div v-if="errors.user_limit" class="text-danger small mt-1">{{ errors.user_limit[0] }}</div>
         </div>
         </div>
              
        </div>

        <div class="row">
         
         <div class="col-md-6">
         <div class="mb-3">
          <label class="form-label">Role</label>
          <vue-select :options="roles" label="name" v-model="role" />
          <div v-if="errors.role_id" class="text-danger small mt-1">{{ errors.role_id[0] }}</div>
         </div>
         </div>

         <div class="col-md-6">
         <div class="mb-3">
          <label class="form-label">Industry</label>
          <vue-select :options="industries" label="name" v-model="industry" />
          <div v-if="errors.industry_id" class="text-danger small mt-1">{{ errors.industry_id[0] }}</div>
         </div>
         </div>
              
        </div>
        
        </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
            <button type="submit" class="btn btn-primary">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add -->

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">
            You want to delete the item, this cant be undone once you delete.
          </p>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteAdmin">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->
</template>